import { PageId } from 'constants/pages'
import type { TPageConfig } from 'models/common.model'
import { PageIdIntl1 } from './pages'
import { HeaderId } from 'root-constants'

export const ID_TO_PAGE_CONFIG_MAP_INTL_1: Record<PageIdIntl1, TPageConfig> = {
  [PageId.ANALYZING]: {
    id: PageId.ANALYZING,
  },
  [PageId.START]: {
    id: PageId.START,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
    legalNotice: 'fixed',
  },
  [PageId.QUESTION_1]: {
    id: PageId.QUESTION_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_2]: {
    id: PageId.QUESTION_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_3]: {
    id: PageId.QUESTION_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_4]: {
    id: PageId.QUESTION_4,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.SPEED_FEEDBACK]: {
    id: PageId.SPEED_FEEDBACK,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_5]: {
    id: PageId.QUESTION_5,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_6]: {
    id: PageId.QUESTION_6,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_7]: {
    id: PageId.QUESTION_7,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_8]: {
    id: PageId.QUESTION_8,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_9]: {
    id: PageId.QUESTION_9,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_10]: {
    id: PageId.QUESTION_10,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_11]: {
    id: PageId.QUESTION_11,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_12]: {
    id: PageId.QUESTION_12,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.SMARTNESS_FEEDBACK]: {
    id: PageId.SMARTNESS_FEEDBACK,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_13]: {
    id: PageId.QUESTION_13,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_14]: {
    id: PageId.QUESTION_14,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_15]: {
    id: PageId.QUESTION_15,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_16]: {
    id: PageId.QUESTION_16,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_17]: {
    id: PageId.QUESTION_17,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_18]: {
    id: PageId.QUESTION_18,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_19]: {
    id: PageId.QUESTION_19,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_20]: {
    id: PageId.QUESTION_20,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.LOGICAL_SKILLS_FEEDBACK]: {
    id: PageId.LOGICAL_SKILLS_FEEDBACK,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_21]: {
    id: PageId.QUESTION_21,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_22]: {
    id: PageId.QUESTION_22,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_23]: {
    id: PageId.QUESTION_23,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_24]: {
    id: PageId.QUESTION_24,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_25]: {
    id: PageId.QUESTION_25,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.AGE_QUESTION]: {
    id: PageId.AGE_QUESTION,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.EDUCATION_QUESTION]: {
    id: PageId.EDUCATION_QUESTION,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.DISCOVER_FEEDBACKS]: {
    id: PageId.DISCOVER_FEEDBACKS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.PREPARE_FLOW]: {
    id: PageId.PREPARE_FLOW,
    hasHeader: true,
    headerId: HeaderId.LOGO_ONLY,
  },
  [PageId.EMAIL]: {
    id: PageId.EMAIL,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.OFFER]: {
    id: PageId.OFFER,
  },
  [PageId.PAYMENT]: {
    id: PageId.PAYMENT,
  },
  [PageId.REGISTRATION]: {
    id: PageId.REGISTRATION,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.NAME_ENTRY]: {
    id: PageId.NAME_ENTRY,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.CERTIFICATE]: {
    id: PageId.CERTIFICATE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.REPORT]: {
    id: PageId.REPORT,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
}
